import { render, staticRenderFns } from "./GetHistory.vue?vue&type=template&id=12bd4ff2&scoped=true&"
import script from "./GetHistory.vue?vue&type=script&lang=js&"
export * from "./GetHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12bd4ff2",
  null
  
)

export default component.exports